import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { editPlant, CreatePlantEditPayload } from "../../Services/serviceURL";

export const editPlantThunk = createAsyncThunk(
    'plant/editPlant',
    async (plantData: CreatePlantEditPayload, { rejectWithValue }) => {
        try {
            const response = await editPlant(plantData);
            return response;
        } catch (error: any) {
            // Extract serializable error information
            const errorInfo = {
                message: error.message || 'Unknown error',
                status: error.response?.status,
                statusText: error.response?.statusText,
                data: error.response?.data
            };
            return rejectWithValue(errorInfo);
        }
    }
);

const createPlantSlice = createSlice({
    name: 'createPlant',
    initialState: {
        loading: false,
        error: null as string | null,
        plantInfo: {
            customer: '',
            site: '',
            plantName: '',
            status: 'Active',
            latitude: '',
            longitude: ''
        },
        siteInfo: {
            customerId: '',
            state: '',
            city: '',
            latitude: '',
            longitude: ''
        }
    },
    reducers: {
        setPlantInfo: (state, action) => {
            state.plantInfo = { ...state.plantInfo, ...action.payload };
        },
        setSiteInfo: (state, action) => {
            state.siteInfo = { ...state.siteInfo, ...action.payload };
        },
        resetPlantForm: (state) => {
            state.plantInfo = {
                customer: '',
                site: '',
                plantName: '',
                status: 'Active',
                latitude: '',
                longitude: ''
            };
            state.siteInfo = {
                customerId: '',
                state: '',
                city: '',
                latitude: '',
                longitude: ''
            };
            state.loading = false;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(editPlantThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(editPlantThunk.fulfilled, (state, action) => {
                state.loading = false;
                // Update plantInfo with response data if available
                if (action.payload?.Data || action.payload) {
                    const responseData = action.payload?.Data || action.payload;
                    if (responseData) {
                        state.plantInfo = {
                            customer: responseData.customer || state.plantInfo.customer,
                            site: responseData.site || state.plantInfo.site,
                            plantName: responseData.plant || responseData.plantName || state.plantInfo.plantName,
                            status: responseData.status || responseData.plantStatus || state.plantInfo.status,
                            latitude: responseData.latitude || state.plantInfo.latitude,
                            longitude: responseData.longitude || state.plantInfo.longitude
                        };
                    }
                }
            })
            .addCase(editPlantThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = typeof action.payload === 'string' ? action.payload : 'Unknown error';
            });
    }
});

export const { setPlantInfo, setSiteInfo, resetPlantForm } = createPlantSlice.actions;

export default createPlantSlice.reducer;